import { GetOrganizationInfoQuery } from "@graphql/generated";
import { create } from "zustand";

export interface IOrganizationStoreState {
  selectedOrganization?: NonNullable<
    NonNullable<NonNullable<GetOrganizationInfoQuery["me"]>["organizationMemberships"]>[0]
  >["organization"];
}

interface IOrganizationStoreAction {
  setSelectedOrganization: (
    selectedOrganization?: NonNullable<
      NonNullable<NonNullable<GetOrganizationInfoQuery["me"]>["organizationMemberships"]>[0]
    >["organization"],
  ) => void;
}

type TOrganizationStore = IOrganizationStoreAction & IOrganizationStoreState;

const initialState: IOrganizationStoreState = {};

export const useOrganizationStore = create<TOrganizationStore>((set) => ({
  ...initialState,
  setSelectedOrganization: (selectedOrganization) => {
    set(() => ({ selectedOrganization }));
  },
}));
